import { render, staticRenderFns } from "./SongMixin.vue?vue&type=template&id=61a90c50&scoped=true"
import script from "./SongMixin.vue?vue&type=script&lang=js"
export * from "./SongMixin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a90c50",
  null
  
)

export default component.exports